export default function AlertPopover({ message, isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.3)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          position: "relative",
          backgroundColor: "white",
          border: "1px solid #ccc",
          borderRadius: "10px",
          padding: "32px",
          width: "400px",
          maxWidth: "90%",
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "12px",
            background: "none",
            border: "none",
            fontSize: "22px",
            fontWeight: "bold",
            cursor: "pointer",
            color: "#666",
          }}
        >
          ×
        </button>
        <div
          style={{
            fontSize: "16px",
            color: "#222",
            textAlign: "center",
            whiteSpace: "pre-line",
          }}
        >
          {message}
        </div>
      </div>
    </div>
  );
}
